export default {"src":"/_next/static/media/notecard-slot.341f0004.gif","height":333,"width":240,"blurWidth":0,"blurHeight":0};